import { Badge } from "@hlcr/mui";
import { PaletteColorKey } from "@hlcr/mui/theme/hacking-lab.theme";
import { useIntl } from "@hlcr/ui/Intl";
import { IconButton, TableCell, Tooltip } from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

import styles from "bugBounty/components/reportedBugsTable.module.scss";
import { BugBountyReportSummary } from "bugBounty/models/BugBountyReport";
import { getBugBountyStatusEnumDetail } from "bugBounty/models/BugBountyStatusEnum";
import { formatFullDate } from "helper/dateCalc";


const ReportBugsTableContent = ({ foundBugs, onRowClick, onCellClick, handleOpenBug }
: {
	foundBugs: BugBountyReportSummary[],
	onRowClick: (bugReport: BugBountyReportSummary, e: any) => void,
	onCellClick: (bugReport: BugBountyReportSummary, e: any) => void,
	handleOpenBug: (eventId: number, bugId: string) => void
}) => {

	const intl = useIntl();
	return (
		<>
			{foundBugs.map((bugReport) => (
				<TableRow
					key={bugReport.id}
					hover
					onClick={(e) => {
						onRowClick(bugReport, e);
					}}
					style={{ cursor: "pointer" }}
				>
					<TableCell
						style={{ width: "300px" }}
					>
						{bugReport.title}
					</TableCell>
					<TableCell
						className={styles.programNameCell}
						onClick={(e) => {
							onCellClick(bugReport, e);
						}}
					>
						{bugReport.programName}
					</TableCell>
					<TableCell>
						<Badge color={(getBugBountyStatusEnumDetail(bugReport.state)?.color ?? "info") as PaletteColorKey}>
							{intl.fm(getBugBountyStatusEnumDetail(bugReport.state)?.title ?? "")}
						</Badge>
					</TableCell>
					<TableCell>
						{bugReport.hunterCvss.score ?? "-"} / {bugReport.triageCvss.score ?? "-"}
					</TableCell>
					<TableCell>
						{bugReport.receivedBounty}
					</TableCell>
					<TableCell>
						{formatFullDate(bugReport.updatedAt)}
					</TableCell>
					<TableCell align="center">
						<Tooltip title={intl.fm("bugBounty.foundBugsTable.openBug")}>
							<IconButton
								onClick={
									(event) => {
										event.stopPropagation();
										handleOpenBug(bugReport.programId, bugReport.id!);
									}}
								size={"small"}
							>
								<OpenInNewIcon />
							</IconButton>
						</Tooltip>
					</TableCell>
				</TableRow>
			))}
		</>
	);
};

export default ReportBugsTableContent;
